if (!customElements.get('product-swatches')) {
    customElements.define('product-swatches', class ProductSwatches extends HTMLElement {
      constructor() {
        super();
        this.productModelId = this.getAttribute("data-product-model-id");
        this.render();
      }
  
      async fetchProductData() {
        try {
          const response = await fetch(`/collections/all?filter.p.m.product.model_id=${this.productModelId}&view=swatches.json`);
          if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const productsObject = await response.json();
          const products = productsObject.products;
          return products;
        } catch (error) {
          console.error(error);
          return [];
        }
      }
  
      async render() {
        const products = await this.fetchProductData();
        const optionsWrapper = this.querySelector('.product-swatches__options-wrapper');
        const currentTitle = this.getAttribute("data-product-title")
  
        // if there is no product modelId, stop the function
        if (!this.productModelId) return

        for (const product of products) {
            const link = document.createElement('a');
            link.classList.add("product-swatches__option");
            link.setAttribute("data-color-option", product.color_id);
            link.setAttribute('href', product.url);
            link.innerHTML = `<img src=${product.img} width="80"></img>`;

            if (currentTitle === product.title) {
                link.classList.add("selected")
            }
            optionsWrapper.appendChild(link);
        }
      }
    });
  }
  